import { getLocale } from '@lmt/expressions/src/expressions/helpers/locale';

export function getFirstDayOfWeek(): 0 | 1 | 2 | 3 | 4 | 5 | 6 {
  return getLocale()?.options?.weekStartsOn ?? 1;
}
